let { anchorate } = require('anchorate')

exports.onRouteUpdate = () => {
  // Scroll to anchor tags when in JS-mode
  anchorate()
}
